export function YearLockBanner({ version, filedAt }: { version: number; filedAt: string | null }) {
  return <div className="rounded-md border border-border bg-foreground px-4 py-3 text-sm font-semibold text-background" data-testid="locked-banner"><span>LOCKED</span> · filed version {version}{filedAt ? ` · ${new Date(filedAt).toLocaleDateString()}` : ''}</div>;
}
